import { getOrderPreparationStatus } from '@/utils/get-order-preparation-status';

export const getOrderStatusTime = ({ order, continuousOrderDisplayTime }) => {
	if (!order) {
		return null;
	}
	// console.log(order);
	const { preparationStatus } = getOrderPreparationStatus(order) || {};

	// console.log(preparationStatus);

	const orderStatusTime = {};
	const dateNow = new Date().getTime();

	// if (order.id == 397970) {
	// 	console.log('oo', order.willBeReadyIn, order.timeSinceAssigned, order.timeSinceReady);
	// 	console.log('edo ', new Date(order.readyAt), new Date(order.assignedAt));
	// }
	if (preparationStatus === 'not-ready') {
		orderStatusTime.className = 'bgDelayed';
		orderStatusTime.time = order.willBeReadyIn;
	} else {
		const readyAt = new Date(order.readyAt);
		const assignedAt = new Date(order.assignedAt);
		if (!order.deliveryId) {
			orderStatusTime.className = 'bgPending';
			orderStatusTime.time = order.timeSinceReady;
		} else if (!order.carrying) {
			orderStatusTime.className = 'bgToPick';
			orderStatusTime.time = continuousOrderDisplayTime
				? order.timeSinceReady
				: readyAt > assignedAt
					? Math.floor((dateNow - new Date(order.readyAt).getTime()) / 1000 / 60)
					: order.timeSinceAssigned;
		} else {
			orderStatusTime.className = 'bgPicked';
			orderStatusTime.time = continuousOrderDisplayTime
				? order.timeSinceReady
				: readyAt > assignedAt
					? Math.floor((dateNow - new Date(order.readyAt).getTime()) / 1000 / 60)
					: order.timeSinceAssigned;
		}
	}

	return { orderStatusTime, preparationStatus };
};
